import { all, call, fork } from "redux-saga/effects";
import userSaga from "modules/user/user-saga";
import diagnosticSaga from "modules/diagnostic/diagnostic-saga";
import modalSaga from "modules/modal/modal-saga";
import authSaga, { loginUser } from "modules/auth/auth-saga";
import { afterLogin as modalAfterLoginSaga } from "modules/modal/modal-saga";

const doNotForceRedirectToHome = () => {
  return (
    process.env.REACT_APP_ENV !== "production" &&
    !!localStorage.getItem("noRedirect")
  );
};

// this might be reverted once the PublicApi is ready
function* initOnlyOnIndex() {
  //uncomment for testing
  // if (
  //   window.location.pathname !== "/" &&
  //   !window.location.pathname.startsWith("/self-diagnosis/finished")
  // ) {
  //   debugger;
  //   yield call([window.location, window.location.replace], "/");
  // }
  if (doNotForceRedirectToHome()) return;

  if (window.location.pathname !== "/") {
    yield call([window.location, window.location.replace], "/");
  }
}

export function* rootSaga() {
  yield call(initOnlyOnIndex);
  yield fork(modalSaga);
  yield call(loginUser);
  yield call(modalAfterLoginSaga);
  yield all([fork(userSaga), fork(diagnosticSaga), fork(authSaga)]);
}



// WEBPACK FOOTER //
// ./src/modules/root/root-saga.js